<template>
  <div class="box">
    <!-- <nav-bar :title="$route.meta.title"></nav-bar> -->

    <div class="content_list">
      <div class="content_list_box">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="content_list_item"
        >
          <div class="item_top">
            <div class="img_box">
              <img
                class="item_img"
                :src="getFilePath(item.resourceRestaurantDTO.filePath)"
              />
              <top-tips
                style="position: absolute; left: 0; top: 0"
                isShowPic="1"
                :money="
                  `${(
                    item.list[0].dealPrice - item.list[0].distributionPrice
                  ).toFixed(2)}` + ''
                "
              ></top-tips>
            </div>
            <div class="title_content">
              <div class="title_detail">
                <div class="title">
                  {{ item.resourceRestaurantDTO.restaurantName }}
                </div>
                <div class="desc">
                  营业时间：
                  {{ item.resourceRestaurantDTO.bussinessTime }}
                  <!-- <span class="first_score">4.8</span>分 <span>1200</span>条评价
                  ¥<span>199</span>/人 -->
                </div>
                <div class="tags">
                  <div
                    v-for="(tag, i) in stringToArr(
                      item.resourceRestaurantDTO.tags
                    )"
                    :key="i"
                    class="tag"
                  >
                    {{ tag }}
                  </div>
                </div>
              </div>
              <div class="order_btn" @click="toDetail(item)">
                订购
              </div>
            </div>
          </div>
          <!-- <div class="bottom_reason">推荐理由：南昌本地人吃的最多的火锅</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navBar from "@/components/nav-bar.vue";
import commonTitle from "../../components/common_title.vue";
import { getImgUrl } from "../../mixins/getImgUrl";
import topTips from "@/new_views/home/components/topTips.vue";
export default {
  components: {
    navBar,
    commonTitle,
    topTips,
  },
  mixins: [getImgUrl],
  data() {
    return {
      list: [],
      tags: ["金牌老店", "明星光顾"],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var params = {
        pageNum: 1,
        pageSize: 10,
        categoryId: this.$route.query.productType,
      };
      this.$API.z_product.getCateringGoodsForOrder(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.list = res.rows;
        }
      });
    },
    stringToArr(item) {
      if (item.length == 0) {
        return [];
      }
      return item.split(",");
    },
    toDetail(item) {
      this.$router.push({
        path: "/restaurant/restaurantDetail",
        query: { ID: item.resourceRestaurantDTO.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  .content_list {
    position: relative;
    padding-bottom: vw(50);
    background-color: #ffffff;
    padding-bottom: vw(30);
    // height: 600px;

    .content_list_box {
      margin-left: vw(30);
      margin-right: vw(30);
      .content_list_item {
        margin-top: vw(30);
        .item_top {
          display: flex;
          flex-direction: row;
          .img_box {
            position: relative;
            .item_img {
              width: vw(200);
              height: vw(200);
              object-fit: cover;
            }
          }

          .title_content {
            position: relative;
            flex: 1;
            margin-left: vw(24);
            .title_detail {
              height: vw(200);
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .title {
                color: #333333;
                font-size: vw(32);
                font-weight: bold;
              }
              .desc {
                color: #333333;
                font-size: vw(24);
                .first_score {
                  color: $theme-color;
                  font-size: vw(42);
                }
              }
              .tags {
                display: flex;
                flex-direction: row;
                align-items: center;
                .tag {
                  margin-right: vw(10);
                  color: #ff7055;
                  font-size: vw(22);
                  border: vw(1) #ff7055 solid;
                  border-radius: vw(4);
                  padding: vw(3) vw(10);
                }
              }
            }
            .order_btn {
              position: absolute;
              right: 0;
              bottom: 0;
              padding: vw(6) vw(20);
              background: linear-gradient(to right, #ff8d33, #ff3030);
              border-radius: vw(8);
              color: #ffffff;
              font-size: vw(26);
              font-weight: bold;
            }
          }
        }
        .bottom_reason {
          margin-top: vw(16);
          color: $theme-color;
          font-size: vw(22);
          padding: vw(6) vw(20);
          background: linear-gradient(to right, #e9f6ff, #f4f6f9);
          border-radius: vw(4);
        }
      }
    }
  }
}
</style>
